import { Component } from "react";


export class DatosUsuario extends Component{

    render(){
        let data = this.props.Usuario;
        return(
           
            <div className="card shadow mb-4">
                <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">{this.props.Titulo}</h6>
                </div>
                <div className="card-body">
                    <div className="form-row">
                        <div className="form-group col-md-2">
                            <label htmlFor="usuario_cedula" className="col-form-label">Cédula</label>
                            <input type="text" id="usuario_cedula" value={data.identificacion??""}  className="form-control" readOnly/>
                        </div>
                        <div className="form-group col-md-1">
                            <label htmlFor="usuario_login" className="col-form-label">Usuario</label>
                            <input type="text" id="usuario_login" value={data.nombreUsuario??""}   className="form-control" readOnly/>
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="usuario_nombre" className="col-form-label">Nombre</label>
                            <input type="text" id="usuario_nombre" value={data.nombreCompleto??""}   className="form-control" readOnly/>
                        </div>
                        <div className="form-group col-md-2">
                            <label htmlFor="usuario_telefono" className="col-form-label">Teléfono</label>
                            <input type="text" id="usuario_telefono" value={data.telefono??""}   className="form-control" readOnly/>
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="usuario_correo" className="col-form-label">Correo Electrónico</label>
                            <input type="text" id="usuario_correo" value={data.correoElectronico??""}  className="form-control" readOnly />
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default DatosUsuario;